import { Headline as AlphaHeadline } from '@oneaudi/unified-web-alpha-components';

export default AlphaHeadline;
